const loggerMiddleware = (conditions) => (storeAPI) => (next) => (action) => {
    conditions?.forEach(({
        actionTypeMatch,
        loggerFunction,
    }) => {
        if (actionTypeMatch(action?.type)) {
            loggerFunction({
                storeAPI,
                action,
            })
        }
    })

    return next(action)
}

export default loggerMiddleware
